import Swiper from 'swiper';

const fullScreenViewerBlock = document.querySelector('.fullscreen-preview');

const hideFullScreenViewer = () => {
  if (fullScreenViewerBlock) fullScreenViewerBlock.classList.remove('_open');
};

const closeButtonHandler = (evt) => {
  evt.preventDefault();

  hideFullScreenViewer();
  evt.target.removeEventListener('click', hideFullScreenViewer);
};

const escapeButtonHandler = (evt) => {
  evt.preventDefault();
  if (evt.key === 'Escape') {
    hideFullScreenViewer();
    window.removeEventListener('keyup', hideFullScreenViewer);
  }
};

const showFullScreenViewer = () => {
  if (fullScreenViewerBlock) fullScreenViewerBlock.classList.add('_open');
};

const getContentForFullScreen = (eventInitiator) => {
  const containerBlock = eventInitiator.closest('.full-screen-viewer__container');
  if (containerBlock) {
    const contentForSlider = containerBlock.querySelectorAll('.full-screen-viewer');
    const formattedContent = [...contentForSlider].map((el) => {
      const copyEl = el.cloneNode(true);
      const imgSrc = el.dataset.originalImg;
      if (imgSrc) {
        const imgElement = document.createElement('img');
        imgElement.src = imgSrc;

        const innerPicture = copyEl.querySelector('picture');
        copyEl.removeChild(innerPicture);
        copyEl.append(imgElement);
      } else {
        copyEl.classList.add('video');
      }

      const blurBlock = copyEl.querySelector('.blur-block');
      if (blurBlock) blurBlock.parentNode.removeChild(blurBlock);

      return copyEl;
    });
    return formattedContent;
  }
  return [];
};

const insertContentIntoViewerBlock = (contentList) => {
  if (!fullScreenViewerBlock) return null;

  const mainSlider = fullScreenViewerBlock.querySelector('.fullscreen-preview__main-slider');
  const additionalSlider = fullScreenViewerBlock.querySelector('.fullscreen-preview__additional-slider');

  if (mainSlider && additionalSlider) {
    const mainSliderChild = mainSlider.querySelector('.swiper-wrapper');
    const additionalSliderChild = additionalSlider.querySelector('.swiper-wrapper');
    if (mainSliderChild) mainSlider.removeChild(mainSliderChild);
    if (additionalSliderChild) additionalSlider.removeChild(additionalSliderChild);

    const sliderWrapper = document.createElement('div');
    sliderWrapper.classList.add('swiper-wrapper');
    contentList.forEach((el) => {
      const copy = el.cloneNode(true);
      const video = copy.querySelector('video');
      if (video) {
        video.style.width = '100%';
        video.style.height = 'auto';
        video.controls = true;
        video.muted = true;
      }

      const slideWrapper = document.createElement('div');
      slideWrapper.classList.add('swiper-slide');
      slideWrapper.append(copy);
      sliderWrapper.append(slideWrapper);
    });
    const cliderWrapperCopy = sliderWrapper.cloneNode(true);
    mainSlider.append(sliderWrapper);
    additionalSlider.append(cliderWrapperCopy);

    const videos = additionalSlider.querySelectorAll('video');
    videos.forEach((el) => {
      el.controls = false;
    });
  }

  return null;
};

const initSlider = () => {
  const additionalSlider = fullScreenViewerBlock.querySelector('.fullscreen-preview__additional-slider');
  const fullScreenAdditionalSlider = new Swiper(additionalSlider, {
    loop: false,
    spaceBetween: 10,
    direction: 'horizontal',
    freeMode: true,
    sliderPerView: 4,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
      390: {
        slidesPerView: 'auto',
        spaceBetween: 5,
      },
      320: {
        slidesPerView: 'auto',
      },
    },
    navigation: {
      nextEl: '.fullscreen-preview__main-slider-next-button',
      prevEl: '.fullscreen-preview__main-slider-prev-button',
    },
  });
  const mainSlider = fullScreenViewerBlock.querySelector('.fullscreen-preview__main-slider');
  new Swiper(mainSlider, {
    loop: false,
    spaceBetween: 0,
    thumbs: {
      swiper: fullScreenAdditionalSlider,
    },
    navigation: {
      nextEl: fullScreenAdditionalSlider.navigation.nextEl,
      prevEl: fullScreenAdditionalSlider.navigation.prevEl,
    },
  });
};

const init = () => {
  const initialBlocks = document.querySelectorAll('.full-screen-viewer');

  initialBlocks.forEach((block) => {
    if (!block.classList.contains('_init')) {
      block.addEventListener('click', (evt) => {
        evt.preventDefault();

        const target = evt.target.classList.contains('full-screen-viewer')
          ? evt.target
          : evt.target.closest('.full-screen-viewer');

        const slidesContentList = getContentForFullScreen(target);
        insertContentIntoViewerBlock(slidesContentList);
        showFullScreenViewer();

        const closeButton = fullScreenViewerBlock.querySelector('.fullscreen-preview__close');
        closeButton.addEventListener('click', closeButtonHandler);
        window.addEventListener('keyup', escapeButtonHandler);

        initSlider();

        block.classList.add('_init');
      });
    }
  });
};

window.fullScreenViewer = init;
